import { callDecimal } from "../utils.ts";

export function logEventToDecimal(
  name: string,
  eventData: Record<string, string | number> = {}
) {
  return callDecimal(
    "/api/v1/events",
    {
      method: "POST",
      body: JSON.stringify({ data: { name, eventData } }),
    },
    // Unlike most endpoints, this isn't wired into the router. Don't throw 401s
    // because they may not have any sort of appropriate default handling in the
    // context they are called in
    { throw401s: false }
  );
}
